"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldTransformHeightExclude = exports.FieldTransformSelectListReplace = exports.FieldTransformNumberInvert = exports.FieldTransformVectorInvert = exports.FieldTransform = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var FieldTransform = /** @class */ (function () {
    function FieldTransform(fieldId, transform) {
        this.fieldId = fieldId;
        this.transform = transform;
    }
    FieldTransform.prototype.match = function (from) {
        return true;
    };
    FieldTransform.create = function (field, transform) {
        var _a;
        if (transform == null) {
            return null;
        }
        var transforms = (_a = {},
            _a[core_api_1.IkeFieldType.VECTOR] = {
                invert: FieldTransformVectorInvert
            },
            _a[core_api_1.IkeFieldType.NUMBER] = {
                invert: FieldTransformNumberInvert
            },
            _a[core_api_1.IkeFieldType.SELECT_LIST] = {
                replace: FieldTransformSelectListReplace
            },
            _a[core_api_1.IkeFieldType.HEIGHT] = {
                exclude: FieldTransformHeightExclude
            },
            _a);
        var fieldTypeTransforms = transforms[field.schema.type];
        if (fieldTypeTransforms == null) {
            return null;
        }
        var transformClass = fieldTypeTransforms[transform.transform];
        if (transformClass == null) {
            return null;
        }
        return new transformClass(field.id, transform);
    };
    return FieldTransform;
}());
exports.FieldTransform = FieldTransform;
var FieldTransformVectorInvert = /** @class */ (function (_super) {
    tslib_1.__extends(FieldTransformVectorInvert, _super);
    function FieldTransformVectorInvert(fieldId, transform) {
        return _super.call(this, fieldId, transform) || this;
    }
    FieldTransformVectorInvert.prototype.match = function (from) {
        return from.hasValue();
    };
    FieldTransformVectorInvert.prototype.apply = function (to) {
        to.Mutator.reverse();
    };
    return FieldTransformVectorInvert;
}(FieldTransform));
exports.FieldTransformVectorInvert = FieldTransformVectorInvert;
var FieldTransformNumberInvert = /** @class */ (function (_super) {
    tslib_1.__extends(FieldTransformNumberInvert, _super);
    function FieldTransformNumberInvert(fieldId, transform) {
        return _super.call(this, fieldId, transform) || this;
    }
    FieldTransformNumberInvert.prototype.match = function (from) {
        return from.hasValue();
    };
    FieldTransformNumberInvert.prototype.apply = function (to) {
        to.Mutator.reverse();
    };
    return FieldTransformNumberInvert;
}(FieldTransform));
exports.FieldTransformNumberInvert = FieldTransformNumberInvert;
var FieldTransformSelectListReplace = /** @class */ (function (_super) {
    tslib_1.__extends(FieldTransformSelectListReplace, _super);
    function FieldTransformSelectListReplace(fieldId, transform) {
        return _super.call(this, fieldId, transform) || this;
    }
    FieldTransformSelectListReplace.prototype.match = function (from) {
        var toValue = this.transform.replace[from.value];
        return toValue != null;
    };
    FieldTransformSelectListReplace.prototype.apply = function (to) {
        var toValue = this.transform.replace[to.value];
        to.Mutator.manual(toValue);
    };
    return FieldTransformSelectListReplace;
}(FieldTransform));
exports.FieldTransformSelectListReplace = FieldTransformSelectListReplace;
var FieldTransformHeightExclude = /** @class */ (function (_super) {
    tslib_1.__extends(FieldTransformHeightExclude, _super);
    function FieldTransformHeightExclude(fieldId, transform) {
        return _super.call(this, fieldId, transform) || this;
    }
    FieldTransformHeightExclude.prototype.apply = function (to) {
        to.Mutator.manual(null);
    };
    return FieldTransformHeightExclude;
}(FieldTransform));
exports.FieldTransformHeightExclude = FieldTransformHeightExclude;
//# sourceMappingURL=field.transform.js.map